var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4 16.3067H23.76C22.4533 16.3067 21.2933 17.0267 20.7066 18.2L19.5866 20.4133C19.32 20.9467 18.7866 21.28 18.2 21.28H13.8266C13.4133 21.28 12.8266 21.1867 12.44 20.4133L11.32 18.2133C10.7333 17.0533 9.55996 16.32 8.26663 16.32H3.59996C3.07996 16.32 2.66663 16.7333 2.66663 17.2533V21.6C2.66663 26.44 5.57329 29.3333 10.4266 29.3333H21.6C26.1733 29.3333 28.9866 26.8267 29.3333 22.3733V17.24C29.3333 16.7333 28.92 16.3067 28.4 16.3067Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5866 2.66669H10.4133C5.55996 2.66669 2.66663 5.56002 2.66663 10.4134V14.4667C2.95996 14.36 3.27996 14.3067 3.59996 14.3067H8.26663C10.3333 14.3067 12.1866 15.4534 13.1066 17.3067L14.1066 19.2667H17.92L18.92 17.2934C19.84 15.4534 21.6933 14.3067 23.76 14.3067H28.4C28.72 14.3067 29.04 14.36 29.3333 14.4667V10.4134C29.3333 5.56002 26.44 2.66669 21.5866 2.66669ZM13.9333 7.21335H18.0666C18.5733 7.21335 19 7.62669 19 8.13335C19 8.65335 18.5733 9.06669 18.0666 9.06669H13.9333C13.4266 9.06669 13 8.65335 13 8.13335C13 7.62669 13.4266 7.21335 13.9333 7.21335ZM19.1066 12.7867H12.8933C12.3866 12.7867 11.9733 12.3734 11.9733 11.8667C11.9733 11.3467 12.3866 10.9334 12.8933 10.9334H19.1066C19.6133 10.9334 20.0266 11.3467 20.0266 11.8667C20.0266 12.3734 19.6133 12.7867 19.1066 12.7867Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirect);
export default __webpack_public_path__ + "static/media/direct.d66176ca25d42ffbddc4309ba8331422.svg";
export { ForwardRef as ReactComponent };